export default {
  namespaced: true,

  state: {
    selectDate: null,
    selectEvent: []
  },

  getters: {
    getSelectDate(state){
        return state.selectDate
    }
  },

  mutations: {
    SET_SELECT_DATE(state, value){
        state.selectDate = value
    },
    SET_SELECT_EVENT(state, value){
      state.selectEvent = []
      value ? state.selectEvent=value : null
    }
  },
}